import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
// import { fetchCrmInstitutesById, updateCrmInstitute } from '../../../services/crmInstituteService';
import { createCrmContact } from '../../../services/crmContactService';

const AddContact = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Institute ID from params

  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    phone: '',
    role: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await createCrmContact({ ...contactData, crm_institute_id: id });
      alert('Contact added successfully');
      navigate(-1);
    } catch {
      setError('Error adding contact');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <h2>Add Contact</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={contactData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={contactData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Phone</Form.Label>
          <Form.Control
            type="text"
            name="phone"
            value={contactData.phone}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Role</Form.Label>
          <Form.Control
            type="text"
            name="role"
            value={contactData.role}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Saving...' : 'Add Contact'}
        </Button>
      </Form>
    </div>
  );
};

export default AddContact;
